<template>
  <div class="row">
    <div class="col-12 d-flex align-items-center">
      <h2>{{ $t('platform_packages.platform_package', 2).capitalize() }}</h2>
      <router-link class="btn btn-primary btn-sm ms-3" :to="{name: ROUTES.PLATFORM_PACKAGES.CREATE}">
        <i class="fas fa-file-circle-plus"/> {{ $t('platform_packages.create') }}
      </router-link>
    </div>

    <div class="col-12">
      <DataTable stripedRows
                 :lazy="true"
                 :paginator="true"
                 :rows="platformPackageStore.serverOptions.rows"
                 :totalRecords="platformPackageStore.itemLength"
                 dataKey="id"
                 :value="platformPackageStore.platform_packages"
                 :loading="platformPackageStore.loading"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10,20,50]"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                 @page="onPage($event)"
                 responsiveLayout="scroll">
        <TableColumn field="id" :header="$t('platform_packages.id')"/>
        <TableColumn field="base_type" :header="$t('platform_packages.base_type')">
          <template #body="{data}">
            {{ $t(`platform_packages.base_types.${data.base_type}`) }}
          </template>
        </TableColumn>
        <TableColumn field="source_kind" :header="$t('platform_packages.source_kind')">
          <template #body="{data}">
            {{ $t(`platform_packages.source_kinds.${data.source_kind}`) }}
          </template>
        </TableColumn>
        <TableColumn field="quantity" :header="$t('platform_packages.quantity')"/>
        <TableColumn field="price_cents" :header="$t('platform_packages.price')">
          <template #body="{data}">
            {{ formatCurrency(data.price_cents / 100) }}
          </template>
        </TableColumn>
        <TableColumn field="price_per_extra_quantity_cents" :header="$t('platform_packages.price_per_extra_quantity')">
          <template #body="{data}">
            {{ formatCurrency(data.price_per_extra_quantity_cents / 100) }}
          </template>
        </TableColumn>
        <TableColumn field="ends_at" :header="$t('platform_packages.ends_at')">
          <template #body="{data}">
            {{ formatDate(data.ends_at, 'datetime') || $t('platform_packages.unlimited') }}
          </template>
        </TableColumn>
        <TableColumn :header="$t('platform_packages.status')">
          <template #body="{data}">
            <span class="badge" :class="isActive(data) ? 'bg-success' : 'bg-secondary'">
              {{ $t(isActive(data) ? 'platform_packages.active' : 'platform_packages.ended') }}
            </span>
          </template>
        </TableColumn>
        <TableColumn :header="$t('platform_packages.operations')">
          <template #body="{data}">
            <div class="operations-wrapper">
              <router-link class="operation-item"
                           :to="{name: ROUTES.PLATFORM_PACKAGES.EDIT, params: {id: data.id}}"
                           :title="$t('platform_packages.edit')">
                <i class="fas fa-edit"/>
              </router-link>
              <button type="button"
                      class="operation-item btn btn-link p-0"
                      :title="$t('delete')"
                      @click="destroyPlatformPackage(data)">
                <i class="fas fa-trash"/>
              </button>
            </div>
          </template>
        </TableColumn>
      </DataTable>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import {usePlatformPackageStore} from '@/stores/platform_package'
import {Helpers} from '@/helpers'
import {ROUTES} from '@/scripts/constants'
import {errorMessages} from '@/pages/platform_packages/helpers'

export default {
  name: 'PlatformPackagesIndex',
  setup() {
    return {
      platformPackageStore: usePlatformPackageStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
  },
  created() {
    this.getPlatformPackages()
    this.setTitle(this.$t('platform_packages.platform_package', 2).capitalize())
  },
  methods: {
    getPlatformPackages() {
      this.platformPackageStore.index().catch((error) => {
        Helpers.emitter.emit('error', errorMessages(error))
      })
    },
    onPage(event) {
      this.platformPackageStore.serverOptions = event
      this.getPlatformPackages()
    },
    isActive(platformPackage) {
      return !platformPackage.ends_at || new Date(platformPackage.ends_at) > new Date()
    },
    destroyPlatformPackage(platformPackage) {
      Swal.fire({
        title: this.$t('delete'),
        text: this.$t('platform_packages.delete_confirm'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('close'),
      }).then(({isConfirmed}) => {
        if (!isConfirmed) {
          return
        }
        this.platformPackageStore.destroy(platformPackage.id).then(() => {
          Helpers.emitter.emit('success', this.$t('platform_packages.deleted'))
        }).catch((error) => {
          Helpers.emitter.emit('error', errorMessages(error))
        })
      })
    },
  },
}
</script>
